import React from "react";
import { useRecordContext } from "react-admin";
import ImageReceiptView from "./ImageReceiptView";
import BillplzReceipt from "./BillplzReceipt";
import { BILLPLZ, HITPAY, HITPAY_MY } from "../Payment/types";

const Comp = (props) => {
  const record = useRecordContext();
  if (
    record.type === BILLPLZ ||
    record.type === HITPAY ||
    record.type === HITPAY_MY
  ) {
    return <BillplzReceipt {...props} record={record} />;
  }
  return <ImageReceiptView {...props} record={record} />;
};

export default Comp;
